import { HTTPStatus } from './ErrorEnums.ts';
import { ErrorDefault } from './Errors.ts';
import { LogSeverity } from './LogSeverity.ts';
(function(ErrorsGeneral) {
    class UserNotFound extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.general.title'
            };
            const message = {
                key: 'strings:popups.errors.general.userNotFound'
            };
            const httpStatus = HTTPStatus.Unauthorized;
            super(title, message, httpStatus);
        }
    }
    ErrorsGeneral.UserNotFound = UserNotFound;
    class InternalServerError extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.internalServerError.title'
            };
            const message = {
                key: 'strings:popups.errors.internalServerError.notifiedDevelopmentTeam'
            };
            const httpStatus = HTTPStatus.InternalServerError;
            const logSeverity = LogSeverity.JL4;
            super(title, message, httpStatus, logSeverity);
        }
    }
    ErrorsGeneral.InternalServerError = InternalServerError;
    class AuthenticationError extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.authenticationError.title'
            };
            const message = {
                key: 'strings:popups.errors.authenticationError.invalidAuthentication'
            };
            const httpStatus = HTTPStatus.InternalServerError;
            const logSeverity = LogSeverity.JL4;
            super(title, message, httpStatus, logSeverity);
        }
    }
    ErrorsGeneral.AuthenticationError = AuthenticationError;
    class UserBanned extends ErrorDefault {
        constructor(bannedUntilString){
            const title = {
                key: 'strings:popups.errors.userBannedError.title'
            };
            const banWithDate = bannedUntilString ? ` until ${bannedUntilString}` : '';
            const message = {
                key: 'strings:popups.errors.userBannedError.youAreBanned',
                options: {
                    untilDate: banWithDate
                }
            };
            const httpStatus = HTTPStatus.Forbidden;
            super(title, message, httpStatus);
        }
    }
    ErrorsGeneral.UserBanned = UserBanned;
    class ErrorUserRateLimitExceeded extends ErrorDefault {
        constructor(remainingTime){
            const title = {
                key: 'strings:popups.errors.userExceededRateLimit.title'
            };
            const message = {
                key: 'strings:popups.errors.userExceededRateLimit.body',
                options: {
                    remainingTime: remainingTime
                }
            };
            const httpStatus = HTTPStatus.TooManyRequests;
            super(title, message, httpStatus);
        }
    }
    ErrorsGeneral.ErrorUserRateLimitExceeded = ErrorUserRateLimitExceeded;
})(ErrorsGeneral || (ErrorsGeneral = {}));
export var ErrorsGeneral;
